import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';
import Logo from '../components/shared/Logo';

export default function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="text-center">
        <Logo className="h-10 mx-auto mb-8" />
        
        <div className="text-8xl font-bold bg-gradient-to-r from-primary to-violet-500 bg-clip-text text-transparent mb-4">
          404
        </div>
        
        <h1 className="text-h1 text-text-primary mb-2">
          Seite nicht gefunden
        </h1>
        <p className="text-text-muted mb-8 max-w-md mx-auto">
          Die Seite, die du suchst, existiert nicht oder wurde verschoben.
        </p>
        
        <div className="flex items-center justify-center gap-4">
          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center gap-2 px-4 py-2 border border-border-default text-text-secondary rounded-lg hover:bg-bg-surface-hover transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Zurück
          </button>
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-primary to-violet-500 text-white rounded-lg hover:opacity-90 transition-opacity"
          >
            <Home className="w-4 h-4" />
            Zur Startseite
          </Link>
        </div>
      </div>
    </div>
  );
}
